import { render, staticRenderFns } from "./AdminDatasetView.vue?vue&type=template&id=86113d46&"
import script from "./AdminDatasetView.vue?vue&type=script&lang=js&"
export * from "./AdminDatasetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports